import { CommonData } from '../common_schema'

export const ioLatencyData: CommonData[] = [
  {
    name: 'Avg TiDB KV Request Duration(for Prewrite)',
    mean: 'Avg_KV_request_duration:by_type.values.mean#Prewrite',
    std: 'Avg_KV_request_duration:by_type.values.std#Prewrite',
    location: 'Performance Overview  --> Avg TiDB KV Request Duration'
  },
  {
    name: 'Avg TiDB KV Request Duration(for Commit)',
    mean: 'Avg_KV_request_duration:by_type.values.mean#Commit',
    std: 'Avg_KV_request_duration:by_type.values.std#Commit',
    location: ''
  },
  {
    name: 'Avg TiDB KV Request Duration(for PessimisticLock)',
    mean: 'Avg_KV_request_duration:by_type.values.mean#PessimisticLock',
    std: 'Avg_KV_request_duration:by_type.values.std#PessimisticLock',
    location: ''
  },
  {
    name: 'Avg TiDB KV Request Duration(for Get)',
    mean: 'Avg_KV_request_duration:by_type.values.mean#Get',
    std: 'Avg_KV_request_duration:by_type.values.std#Get',
    location: ''
  },
  {
    name: 'Avg TiDB KV Request Duration(for Cop)',
    mean: 'Avg_KV_request_duration:by_type.values.mean#Cop',
    std: 'Avg_KV_request_duration:by_type.values.std#Cop',
    location: ''
  },
  {
    name: 'Avg TiKV gRPC Duration(for kv_prewrite)',
    mean: 'Avg_TiKV_gRPC_duration:by_type.values.mean#kv_prewrite',
    std: 'Avg_TiKV_gRPC_duration:by_type.values.std#kv_prewrite',
    location: 'Performance Overview  --> Avg TiKV gRPC Duration'
  },
  {
    name: 'Avg TiKV gRPC Duration(for kv_commit)',
    mean: 'Avg_TiKV_gRPC_duration:by_type.values.mean#kv_commit',
    std: 'Avg_TiKV_gRPC_duration:by_type.values.std#kv_commit',
    location: ''
  },
  {
    name: 'Avg TiKV gRPC Duration(for kv_pessimistic_lock)',
    mean: 'Avg_TiKV_gRPC_duration:by_type.values.mean#kv_pessimistic_lock',
    std: 'Avg_TiKV_gRPC_duration:by_type.values.std#kv_pessimistic_lock',
    location: ''
  },
  {
    name: 'Avg TiKV gRPC Duration(for kv_get)',
    mean: 'Avg_TiKV_gRPC_duration:by_type.values.mean#kv_get',
    std: 'Avg_TiKV_gRPC_duration:by_type.values.std#kv_get',
    location: ''
  },
  {
    name: 'Avg TiKV gRPC Duration(for coprocessor)',
    mean: 'Avg_TiKV_gRPC_duration:by_type.values.mean#coprocessor',
    std: 'Avg_TiKV_gRPC_duration:by_type.values.std#coprocessor',
    location: ''
  }
]
